











































import Vue from 'vue'
import { SmallMonthlyInvoiceElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'SmallMonthlyInvoiceEl',

  methods: {
    downloadPdfBill (): void {
      if (Object.prototype.hasOwnProperty.call(this.templateItemData, 'pdfUri')) {
        window.open(this.templateItemData.pdfUri, '_blank')
      }
    }
  },

  props: {
    templateItemData: {
      type: Object as () => SmallMonthlyInvoiceElInterface,
      required: true
    }
  }
})
